import { useRef, useState } from 'react'

import { ISessionRefreshView, ISessionUseRefreshView } from '../types'

const useRefreshView: ISessionUseRefreshView = () => {
  const [_, refresh] = useState<object>(null)
  const refreshViewRef = useRef<{ refreshView: ISessionRefreshView; debounceTimer: ReturnType<typeof setTimeout> }>(
    null
  )
  if (null == refreshViewRef.current) {
    refreshViewRef.current = {
      refreshView: () => {
        if (refreshViewRef.current.debounceTimer) {
          clearTimeout(refreshViewRef.current.debounceTimer)
        }
        refreshViewRef.current.debounceTimer = setTimeout(() => {
          refreshViewRef.current.debounceTimer = null
          try {
            refresh({})
          } catch {
            // ignore
          }
        }, 0)
      },
      debounceTimer: null
    }
  }

  return refreshViewRef.current.refreshView
}

export default useRefreshView
